export const getPageName = function(pageType, propertyStatus, returnStatusOnly=false) {
  var status;
  if (pageType === 'ldp' || pageType === 'ldp-quickview') {
    switch(propertyStatus) {
    case 'for_sale':
      status = 'for_sale';
      break;
    case 'new_community':
      status = 'for_sale';
      break;
    case 'for_rent':
      status = 'for_rent';
      break;
    case 'not_for_sale':
      status = 'not_for_sale';
      break;
    default:
      status = 'for_sale';
      break;
    }
  } else if (pageType === 'bdp') {
    status = 'for_sale';
  }
  return (returnStatusOnly ? status : `${status}:${pageType}`);
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/tracking_helper.js